<template>
    <v-btn class="kp-btn-action" v-bind="$attrs" :color="color" depressed small v-on="$listeners">
        <slot></slot>
    </v-btn>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ActionBtn',
    props: {
        color: {
            type: String,
            default: 'action white--text',
        },
    },
});
</script>

<style lang="scss" scoped>
.kp-btn-action.v-item--active.v-btn.v-btn.v-btn {
    background-color: var(--v-primaryToggled-base) !important;
    &::before {
        opacity: 0;
    }
}
</style>
